import React, { useEffect } from 'react';
import mainMenuConfig, { publicMenuConfig } from 'config/main-menu.config';
import { useAuth } from 'auth/AuthContext';
import { normalize } from 'utils/stringUtils';

import logoPNG from 'ksk/assets/template/siconfi-no-subtitle-dark-blue.png';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const LOCAL_STORAGE_KEY = 'mainMenuOpenMenus';

function MainMenu() {
  const { isAuthenticated, isAuthorized } = useAuth();
  const [openMenus, setOpenMenus] = React.useState({});
  const location = useLocation();

  const currentMenuConfig = isAuthenticated ? mainMenuConfig : publicMenuConfig;

  useEffect(() => {
    const currentPath = location.pathname;
  
    const submenuIndex = currentMenuConfig.submenus.findIndex((submenu) =>
      submenu.items.some((item) => currentPath.includes(`/${item.feature.route.url}`))
    );
  
    if (submenuIndex !== -1) {
      // Se o path atual bate com algum submenu, abrimos ele (e apenas ele) e salvamos no localStorage
      const updated = { [submenuIndex]: true };
      setOpenMenus(updated);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
    } else {
      // Senão, limpamos qualquer estado salvo anteriormente
      setOpenMenus({});
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  
    // Inicializa BRMenu uma única vez após autenticação (ou no carregamento do public menu)
    if (window.core?.BRMenu) {
      const brMenu = document.querySelector('.br-menu');
      if (brMenu && !brMenu.classList.contains('initialized')) {
        new window.core.BRMenu('br-menu', brMenu);
        brMenu.classList.add('initialized');
      }
    }
  }, [location.pathname, isAuthenticated, currentMenuConfig]);
 
  const closeMenu = () => {
    const brMenu = document.querySelector('.br-menu');
    if (brMenu?.classList.contains('active')) {
      const closeBtn = brMenu.querySelector('[data-dismiss="menu"]');
      closeBtn?.click();
    }
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const toggleMenu = (index) => {
    setOpenMenus((prev) => {
      const isCurrentlyOpen = !!prev[index];
      const updated = isCurrentlyOpen ? {} : { [index]: true }; // só deixa 1 aberto
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }; 

  const verifyPermissionAndApplyFilter = (filter, isAuthorized) => (item) =>
    isAuthorized?.(item.feature.requires) &&
    normalize(item.feature.name).toUpperCase().includes(normalize(filter).toUpperCase());

  const renderMenuItem = (item) => {
    const itemPath = `/${item.feature.route.url}`;
    const isActive = location.pathname.includes(itemPath);
  
    return (
      <li key={item.feature.route.url}>
        <Link
          className={`menu-item ${isActive ? 'active' : ''}`}
          to={itemPath}
          role="treeitem"
        >
          <span className="content">{item.feature.name}</span>
        </Link>
      </li>
    );
  };

  const renderSubmenu = (submenu, index) => {
    const filteredItems = submenu.items.filter(
      verifyPermissionAndApplyFilter('', isAuthorized)
    );
    if (filteredItems.length === 0) return null;
  
    const isOpen = openMenus[index];
  
    return (
      <div className={`menu-folder ${isOpen ? 'active' : ''} drop-menu`} key={index}>
        <a
          className="menu-item"
          role="treeitem"
          aria-expanded={isOpen}
          aria-haspopup="true"
          data-click-listener="true"
          onClick={() => toggleMenu(index)}
          style={{ cursor: 'pointer' }}
        >
          <span className="content">{submenu.label}</span>
          <span className="support">
            <i className="fas fa-chevron-down" aria-hidden="true"></i>
          </span>
        </a>
  
        {isOpen && (
          <ul>
            {filteredItems.map(renderMenuItem)}
          </ul>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="br-menu small" id="main-navigation">
        <div className="menu-container">
          <div className="menu-panel">
            <div className="menu-header">
              <div className="menu-title">
                <img src={logoPNG} alt="logo" />
              </div>
              <div className="menu-close">
                <button
                  className="br-button circle"
                  type="button"
                  aria-label="Fechar o menu"
                  data-dismiss="menu"
                >
                  <i className="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <nav className="menu-body" role="tree">
              {currentMenuConfig.submenus.map(renderSubmenu)}
            </nav>
          </div>
          <div className="menu-scrim" data-dismiss="menu" tabIndex="0"></div>
        </div>
      </div>
    </>
  );
}

export default MainMenu;
